var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$root.isMobile)?_c('div',{class:_vm.$style.meta},[_c('locale-date-time',{attrs:{"date":_vm.entry.createdAt}})],1):_vm._e(),_vm._v(" "),_c('div',{class:_vm.$style.message,domProps:{"innerHTML":_vm._s(_vm.messageAsHtml)}})])}
var staticRenderFns = []

export { render, staticRenderFns }